module.exports = __webpack_public_path__ + "images/img-2nVh4l6.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/ru/13.png
// module id = 2350
// module chunks = 0